import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FaCompassDrafting, FaBoreHole } from 'react-icons/fa6';
import { GiSoundWaves } from 'react-icons/gi';
import logo from '../../assets/Axiom-Logo.png';

const FEATURES = [
  { icon: 'bi-kanban', label: 'Projects' },
  { icon: 'bi-people', label: 'HR' },
  { icon: 'bi-shield-check', label: 'QHSE' },
  { icon: 'bi-cash-coin', label: 'Finance' },
  { icon: 'bi-boxes', label: 'Inventory' },
  { Icon: FaCompassDrafting, label: 'Survey' },
  { Icon: FaBoreHole, label: 'Drilling' },
  { Icon: GiSoundWaves, label: 'Recording' },
];

const AboutModal = ({ show, handleClose }) => (
  <Modal
    show={show}
    onHide={handleClose}
    centered
    contentClassName="border-0"
    style={{ backdropFilter: 'blur(5px)' }}
  >
    <div
      style={{
        position: 'relative',
        background: 'linear-gradient(135deg, var(--archon-navy-deep) 0%, var(--archon-navy-mid) 55%, var(--archon-navy-light) 100%)',
        borderRadius: '8px',
        overflow: 'hidden',
      }}
    >
      <div
        aria-hidden="true"
        style={{
          position: 'absolute',
          inset: '2mm',
          zIndex: 2,
          border: '3px solid var(--archon-accent)',
          borderRadius: '8px',
          boxShadow: '0 0 5px var(--archon-about-avatar-shadow)',
          pointerEvents: 'none',
        }}
      />

      <Modal.Header
        closeButton
        closeVariant="white"
        style={{
          border: 'none',
          paddingBottom: 0,
        }}
      />

      <Modal.Body style={{ color: 'var(--archon-about-body-text)', paddingTop: 0 }}>
        <div className="text-center">
          <div
            style={{
              width: '84px',
              height: '84px',
              margin: '0 auto 1rem',
              borderRadius: '20px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: 'var(--archon-about-accent-glow-bg)',
              boxShadow: '0 0 0 1px var(--archon-about-accent-glow-ring), 0 8px 24px var(--archon-about-accent-glow-shadow)',
            }}
          >
            <img src={logo} alt="ArchonPM" style={{ width: '52px', height: '52px', objectFit: 'contain' }} />
          </div>

          <h4 className="mb-1" style={{ color: 'var(--archon-white)', fontWeight: 700, letterSpacing: '0.02em' }}>
            ArchonPM
          </h4>
          <div className="mb-3" style={{ color: 'var(--archon-dark-shell-text-muted)', fontSize: '0.85rem' }}>
            Project Management for Energy
          </div>

          <div className="d-flex justify-content-center flex-wrap" style={{ gap: '8px' }}>
            <span
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px',
                padding: '4px 12px',
                borderRadius: '999px',
                fontSize: '0.8rem',
                fontWeight: 600,
                color: 'var(--archon-accent-blue)',
                backgroundColor: 'var(--archon-about-badge-bg)',
                border: '1px solid var(--archon-about-badge-border)',
              }}
            >
              <i className="bi bi-patch-check-fill" aria-hidden />
              Version 2.0 Beta
            </span>
            <span
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px',
                padding: '4px 12px',
                borderRadius: '999px',
                fontSize: '0.8rem',
                fontWeight: 600,
                color: 'var(--archon-accent)',
                backgroundColor: 'var(--archon-about-accent-badge-bg)',
                border: '1px solid var(--archon-accent-soft)',
              }}
            >
              <i className="bi bi-calendar3" aria-hidden />
              Released July 15, 2026
            </span>
          </div>

          <p className="mt-3 mb-4" style={{ color: 'var(--archon-about-lead-text)', lineHeight: '1.6', fontSize: '0.95rem' }}>
            ArchonPM is a project management application designed for seismic acquisition
            projects in the energy industry.
          </p>

          <div
            className="d-flex flex-wrap justify-content-center"
            style={{ gap: '8px', marginBottom: '1.25rem' }}
          >
            {FEATURES.map((feature) => (
              <div
                key={feature.label}
                className="d-flex align-items-center"
                style={{
                  gap: '6px',
                  padding: '6px 10px',
                  borderRadius: '8px',
                  fontSize: '0.78rem',
                  color: 'var(--archon-about-feature-text)',
                  backgroundColor: 'var(--archon-navy-deep)',
                  border: '1px solid var(--archon-navy-light)',
                }}
              >
                {feature.Icon ? (
                  <feature.Icon style={{ color: 'var(--archon-accent-blue)', fontSize: '0.85rem' }} aria-hidden />
                ) : (
                  <i className={`bi ${feature.icon}`} style={{ color: 'var(--archon-accent-blue)' }} aria-hidden />
                )}
                {feature.label}
              </div>
            ))}
          </div>

          <div style={{ borderTop: '1px solid var(--archon-about-divider)', paddingTop: '1rem' }}>
            <div className="mb-1" style={{ fontSize: '0.95rem' }}>
              Developed by{' '}
              <a
                href="https://www.ChrisallTech.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: 'var(--archon-accent-blue)', fontWeight: 700, textDecoration: 'none' }}
              >
                Chrisall Technologies
              </a>
            </div>
            <div className="mb-2" style={{ color: 'var(--archon-about-footer-text)', fontSize: '0.85rem' }}>
              © 2026 Chrisall Technologies. All rights reserved.
            </div>
            <p className="mb-0" style={{ color: 'var(--archon-about-footer-text-soft)', fontSize: '0.8rem', lineHeight: '1.5' }}>
              This beta version is under active development and may contain bugs or incomplete
              features. We welcome feedback and suggestions!
            </p>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer style={{ border: 'none', paddingTop: 0 }}>
        <Button
          onClick={handleClose}
          style={{
            background: 'linear-gradient(135deg, var(--archon-accent-blue) 0%, var(--archon-about-gradient-end) 100%)',
            border: 'none',
            fontWeight: 600,
            padding: '0.5rem 1.5rem',
          }}
        >
          Close
        </Button>
      </Modal.Footer>
    </div>
  </Modal>
);

export default AboutModal;
